export enum ROLES {
  ADMINISTRATOR = 'Administrator',
}
